import { authClient, API } from '../index'

// Get all clients
export const getClients = () => {
  return authClient().get(`${API}/client`)
}

export const getClientsByTherapistId = (id) => {
  return authClient().get(`${API}/client/therapist/${id}`)
}

// Get client by id
export const getClientById = (id) => {
  return authClient().get(`${API}/client/${id}`)
}

// Delete client
export const deleteClient = (id) => {
  return authClient().delete(`${API}/client/${id}`)
}

// Create client
export const postClient = (client) => {
  return authClient().post(`${API}/client`, client)
}

// Update client
export const updateClient = (id, client) => {
  return authClient().put(`${API}/client/${id}`, client)
}

export const changeStatusClient = (id, active) => {
  return authClient().put(`${API}/client/change-status/${id}`, { active });
}

export const sendWelcomeEmail = (id) => {
  return authClient().post(`${API}/client/welcome-email/${id}`);
}

export const sendAppointmentEmail = (id, block) => {
  return authClient().post(`${API}/client/appointment-email/${id}`, { block });
}

export const changeStatusBlockClient = (id, block, active, note, extra = {}) => {
  return authClient().put(`${API}/client/change-status-block/${id}`, {
    active,
    block,
    note,
    ...extra,
  });
}